import { isFunction } from 'lodash';

export const errorFragments = [
  '/core-js',
  '/runtime.js',
  '/vue.js',
  '/vue.esm.js',
  '/vue.min.js',
  '/vue.runtime.esm.js',
  '/asyncToGenerator.js',
  '/template-compiler/index.js'
];

export default {
  name: 'errorHandlerPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, options) {
    const log = Vue.prototype.$xpc.log;

    const errorHandlers = [Vue.config.errorHandler].filter(fn =>
      isFunction(fn)
    );

    /**
     * 修改 Vue.config.errorHandler
     * 变更为 getter/setter 模式
     *
     * 防止出现XPC项目中的errorHandler被外部覆盖的情况
     */
    Object.defineProperty(Vue.config, 'errorHandler', {
      get () {
        return function (...args) {
          errorHandlers.forEach(fn => isFunction(fn) && fn(...args));
        };
      },
      set (handler) {
        if (
          isFunction(handler) &&
          errorHandlers.every(fn => fn.toString() !== handler.toString())
        ) {
          errorHandlers.push(handler);

          if (errorHandlers.length > 20) {
            log(
              'errorHandler 处理函数超长，请检查是否重复为 Vue.config.errorHandler 进行赋值！'
            );
          }
        }
      }
    });

    /**
     * 定义XPC内部的errorHandler函数，通过上方的 setter 函数设置到对应的函数数组中
     *
     * @param {*} err
     * @param {*} vm
     * @param {*} info
     */
    Vue.config.errorHandler = (err, vm, info) => {
      let errMsg = {
        err: err,
        vm: vm,
        info: info
      };

      let errStack = err;

      if (typeof err === 'object' && err && err.stack) {
        errStack = err.stack.split('\n').filter(item => item.indexOf('vue.esm.js') === -1);
      }

      if (err) {
        const color = 'color:red';
        log([
          ['%c错误发生生命周期钩子', color, info],
          ['%c错误发生详细描述（错误描述、发生文件、发生行）', color, errStack],
          ['%c更多错误信息', color, errMsg]
        ]);
      }
    };
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/errorHandler/index.js